import 'bootstrap/dist/css/bootstrap.min.css';

import Svg_Hizli from '../assets/img/svg/ico_hizli_mobilassistance.svg'
import Svg_Seckin from '../assets/img/svg/ico_seckin_mobilassistance.svg'
import Svg_Teknolojik from '../assets/img/svg/ico_teknoloji_mobilassistance.svg'
import Svg_KolayErisim from '../assets/img/svg/ico_kolayersisim_mobilassistance.svg'
import Svg_Memnuniyet from '../assets/img/svg/ico_musteri_memnuniyet_mobilassistance.svg'
import Svg_Guven from '../assets/img/svg/ico_guven_mobilassistance.svg'

function WhyMobilassistance() {
    const whyCards = [
        {
            icon: Svg_Hizli,
            title: 'Hızlı ve Profesyonel Hizmet',
            description: 'Dakikalar içerisinde müdahale ederek kısa sürede etkili çözümler üretiyoruz.',
            color: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            delay: 200
        },
        {
            icon: Svg_Guven,
            title: 'Güven Veren Sektör Deneyimi',
            description: 'Sektörde lider olan altyapımızla en uygun ve kaliteli hizmeti sunuyoruz.',
            color: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            delay: 300
        },
        {
            icon: Svg_Seckin,
            title: 'Seçkin Tedarikçi Ağı',
            description: 'Türkiye geneli seçkin tedarikçi ağımızla ülkenin dört bir yanına hizmet sağlıyoruz.',
            color: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            iconBg: 'linear-gradient(135deg, #3D271A 0%, #6B4423 100%)',
            delay: 400
        },
        {
            icon: Svg_Memnuniyet,
            title: '%100 Müşteri Memnuniyeti',
            description: '81 ilde, müşteri odaklı ve %100 memnuniyet oranlı hizmet veriyoruz.',
            color: 'linear-gradient(135deg, #80909C 0%, #A1BCD1 100%)',
            iconBg: 'linear-gradient(135deg, #80909C 0%, #A1BCD1 100%)',
            delay: 500
        },
        {
            icon: Svg_KolayErisim,
            title: 'Kolay Ulaşılabilir Yapı',
            description: '7/24 ulaşılabilir Assistance Çağrı Merkezi ile ihtiyaç duyduğunuz her an yanınızda oluyoruz.',
            color: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            iconBg: 'linear-gradient(135deg, #ff7e00 0%, #f9b224 100%)',
            delay: 600
        },
        {
            icon: Svg_Teknolojik,
            title: 'Güçlü ve Teknolojik Altyapı',
            description: 'Güçlü ve teknolojik altyapımız ile kolay ve anında hizmet vadediyoruz.',
            color: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            iconBg: 'linear-gradient(135deg, #0083BF 0%, #052B49 100%)',
            delay: 700
        }
    ];

    return (
        <>
        <section className="standard-section">
                <div className="standard-container">
                    <div className="standard-section-title">
                        <div className="standard-section-title__sub-title" data-aos="fade-up" data-aos-delay="200">
                            NEDEN MOBİL ASSISTANCE
                        </div>
                        <div className="standard-section-title__main" data-aos="fade-up" data-aos-delay="400">
                            <p className="standard-section-title__main--desc">
                                Güvenilir, hızlı ve kaliteli hizmet anlayışımızla 
                                sektörde öncü bir asistans destek hizmeti sunuyoruz.
                            </p>
                        </div>
                    </div>

                        <div className="row g-4">
                            {whyCards.map((card, index) => (
                                <div 
                                    key={index} 
                                    className="col-lg-4 col-md-6" 
                                    data-aos="fade-up" 
                                    data-aos-delay={card.delay}
                                >
                                    <div className="elegant-stats-card">
                                        <div className="elegant-stats-card__header">
                                            <div className="elegant-stats-card__icon" style={{ background: card.iconBg }}>
                                                <img 
                                                    src={card.icon} 
                                                    alt={card.title} 
                                                    className="elegant-icon-image"
                                                />
                                            </div>
                                            <div className="elegant-stats-card__decoration-line"></div>
                                        </div>
                                        <div className="elegant-stats-card__body">
                                            <div className="elegant-stats-card__title">{card.title}</div>
                                            <div className="elegant-stats-card__description">
                                                {card.description}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                    </div>
                </div>
        </section>
        </>
    );
};

export default WhyMobilassistance;